// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Js_list from "../../../../../../../node_modules/rescript/lib/es6/js_list.js";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Js_string from "../../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Caml_array from "../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as PageviewStore$PorterinFeature from "../store/PageviewStore.mjs";
import * as CategoryAnalyticsStore$PorterinFeature from "../store/CategoryAnalyticsStore.mjs";

function getRoutePathList(str) {
  return Belt_Option.getWithDefault(Belt_List.tail($$Array.to_list(Js_string.split("/", str))), /* [] */0);
}

function getPillarPageName(url, index) {
  return Belt_Option.getWithDefault(Js_list.nth(getRoutePathList(url), index), "");
}

function getPillarOmsPageName(url, defaultValue) {
  var path = Js_string.split("?", url);
  var match = path.length;
  if (match !== 0) {
    return Caml_array.get(path, 0);
  } else {
    return defaultValue;
  }
}

function getCategoryName(router) {
  var match = getRoutePathList(router.pathname);
  if (!match) {
    return CategoryAnalyticsStore$PorterinFeature.$$default;
  }
  switch (match.hd) {
    case "" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.home;
        }
    case "about-us" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.about_us;
        }
    case "careers" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.careers;
        }
    case "city" :
        var match$1 = match.tl;
        if (match$1 && !match$1.tl) {
          return CategoryAnalyticsStore$PorterinFeature.city + Js_string.sliceToEnd(PageviewStore$PorterinFeature.ga_path_city_page_prefix.length, getPillarOmsPageName(router.asPath, ""));
        } else {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        }
    case "courier" :
        var match$2 = match.tl;
        if (match$2) {
          if (match$2.hd === "tnc") {
            if (match$2.tl) {
              return CategoryAnalyticsStore$PorterinFeature.$$default;
            } else {
              return CategoryAnalyticsStore$PorterinFeature.courier_tnc;
            }
          } else if (match$2.tl) {
            return CategoryAnalyticsStore$PorterinFeature.$$default;
          } else {
            return CategoryAnalyticsStore$PorterinFeature.courier_city + getPillarOmsPageName(getPillarPageName(router.asPath, 1), "");
          }
        } else {
          return CategoryAnalyticsStore$PorterinFeature.courier;
        }
    case "enterprise" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.enterprise;
        }
    case "enterprise-faq" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.enterprise_faq;
        }
    case "enterprise-lead-page" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.enterprise_lead_page;
        }
    case "fare-estimate" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.fare_estimate;
        }
    case "fare_estimate_mob" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.fare_estimate_mob;
        }
    case "governance" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.governance;
        }
    case "insurance-faq" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.insurance_faq;
        }
    case "offers" :
        var match$3 = match.tl;
        if (!match$3) {
          return CategoryAnalyticsStore$PorterinFeature.offers;
        }
        switch (match$3.hd) {
          case "cashback" :
              var match$4 = match$3.tl;
              if (match$4 && !match$4.tl) {
                return CategoryAnalyticsStore$PorterinFeature.offers_cashback;
              } else {
                return CategoryAnalyticsStore$PorterinFeature.$$default;
              }
          case "discount" :
              var match$5 = match$3.tl;
              if (match$5 && !match$5.tl) {
                return CategoryAnalyticsStore$PorterinFeature.offers_discount;
              } else {
                return CategoryAnalyticsStore$PorterinFeature.$$default;
              }
          default:
            return CategoryAnalyticsStore$PorterinFeature.$$default;
        }
    case "order-history" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.order_history;
        }
    case "order-review" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.order_review;
        }
    case "packers-and-movers" :
        var match$6 = match.tl;
        if (!match$6) {
          return CategoryAnalyticsStore$PorterinFeature.pnm_pillar;
        }
        var match$7 = match$6.tl;
        if (match$7) {
          if (match$7.tl) {
            return CategoryAnalyticsStore$PorterinFeature.$$default;
          } else {
            return CategoryAnalyticsStore$PorterinFeature.pnm_hyperlocal + getPillarOmsPageName(getPillarPageName(router.asPath, 1), CategoryAnalyticsStore$PorterinFeature.$$default) + getPillarOmsPageName(getPillarPageName(router.asPath, 2), CategoryAnalyticsStore$PorterinFeature.$$default);
          }
        } else {
          return CategoryAnalyticsStore$PorterinFeature.pnm_city + getPillarOmsPageName(getPillarPageName(router.asPath, 1), CategoryAnalyticsStore$PorterinFeature.$$default);
        }
    case "partners" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.partners;
        }
    case "porter-wallet-faq" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.porter_wallet_faq;
        }
    case "privacy-policy" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.privacy_policy;
        }
    case "privacy-policy-v1" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.privacy_policy_v1;
        }
    case "privacy-policy-v2" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.privacy_policy_v2;
        }
    case "referral-tnc" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.referral_tnc;
        }
    case "services" :
        var match$8 = match.tl;
        if (!match$8) {
          return CategoryAnalyticsStore$PorterinFeature.services_pillar;
        }
        if (!match$8.tl) {
          return CategoryAnalyticsStore$PorterinFeature.services_keyword + getPillarOmsPageName(getPillarPageName(router.asPath, 1), CategoryAnalyticsStore$PorterinFeature.$$default);
        }
        switch (match$8.hd) {
          case "courier" :
              if (match$8.tl.tl) {
                return CategoryAnalyticsStore$PorterinFeature.$$default;
              } else {
                return CategoryAnalyticsStore$PorterinFeature.services_courier_keyword + getPillarOmsPageName(getPillarPageName(router.asPath, 2), CategoryAnalyticsStore$PorterinFeature.$$default);
              }
          case "trucks" :
              if (match$8.tl.tl) {
                return CategoryAnalyticsStore$PorterinFeature.$$default;
              } else {
                return CategoryAnalyticsStore$PorterinFeature.services_trucks_keyword + getPillarOmsPageName(getPillarPageName(router.asPath, 2), CategoryAnalyticsStore$PorterinFeature.$$default);
              }
          case "two-wheelers" :
              if (match$8.tl.tl) {
                return CategoryAnalyticsStore$PorterinFeature.$$default;
              } else {
                return CategoryAnalyticsStore$PorterinFeature.services_2w_keyword + getPillarOmsPageName(getPillarPageName(router.asPath, 2), CategoryAnalyticsStore$PorterinFeature.$$default);
              }
          default:
            return CategoryAnalyticsStore$PorterinFeature.$$default;
        }
    case "spot-faq" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.spot_faq;
        }
    case "support" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.support;
        }
    case "terms-of-service" :
        var match$9 = match.tl;
        if (match$9) {
          if (match$9.hd === "partners" && !match$9.tl) {
            return CategoryAnalyticsStore$PorterinFeature.terms_of_service_partners;
          } else {
            return CategoryAnalyticsStore$PorterinFeature.$$default;
          }
        } else {
          return CategoryAnalyticsStore$PorterinFeature.terms_of_service;
        }
    case "tools" :
        var match$10 = match.tl;
        if (match$10) {
          if (match$10.tl) {
            return CategoryAnalyticsStore$PorterinFeature.$$default;
          } else {
            return CategoryAnalyticsStore$PorterinFeature.utility_tools + getPillarOmsPageName(getPillarPageName(router.asPath, 1), "");
          }
        } else {
          return CategoryAnalyticsStore$PorterinFeature.utility_tools_main;
        }
    case "track-order" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return CategoryAnalyticsStore$PorterinFeature.track_order;
        }
    case "trucks" :
        var match$11 = match.tl;
        if (match$11) {
          if (match$11.tl) {
            return CategoryAnalyticsStore$PorterinFeature.$$default;
          } else {
            return CategoryAnalyticsStore$PorterinFeature.trucks_city + Js_string.sliceToEnd(PageviewStore$PorterinFeature.ga_path_trucks_prefix.length, getPillarOmsPageName(router.asPath, ""));
          }
        } else {
          return CategoryAnalyticsStore$PorterinFeature.trucks_pillar;
        }
    case "two-wheelers" :
        var match$12 = match.tl;
        if (match$12) {
          if (match$12.tl) {
            return CategoryAnalyticsStore$PorterinFeature.$$default;
          } else {
            return CategoryAnalyticsStore$PorterinFeature.v2_2w_city + Js_string.sliceToEnd(PageviewStore$PorterinFeature.ga_path_bike_parcel_keyword_prefix.length, getPillarOmsPageName(router.asPath, ""));
          }
        } else {
          return CategoryAnalyticsStore$PorterinFeature.bikes_pillar;
        }
    default:
      return CategoryAnalyticsStore$PorterinFeature.$$default;
  }
}

function getNumberedEventLabel(labels) {
  var modified_labels = List.mapi((function (index, label) {
          return String(index + 1 | 0) + "_" + label;
        }), labels);
  return $$String.concat("#", modified_labels);
}

function getPageName(pathname) {
  var match = getRoutePathList(pathname);
  if (!match) {
    return CategoryAnalyticsStore$PorterinFeature.$$default;
  }
  switch (match.hd) {
    case "" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "home";
        }
    case "about-us" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "about_us";
        }
    case "bike-parcel" :
        var match$1 = match.tl;
        if (match$1 && !match$1.tl) {
          return "2w";
        } else {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        }
    case "careers" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "careers";
        }
    case "city" :
        var match$2 = match.tl;
        if (match$2 && !match$2.tl) {
          return "city";
        } else {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        }
    case "courier" :
        var match$3 = match.tl;
        if (match$3) {
          if (match$3.hd === "tnc") {
            if (match$3.tl) {
              return CategoryAnalyticsStore$PorterinFeature.$$default;
            } else {
              return "courier_tnc";
            }
          } else if (match$3.tl) {
            return CategoryAnalyticsStore$PorterinFeature.$$default;
          } else {
            return "courier";
          }
        } else {
          return "courier";
        }
    case "enterprise" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "enterprise";
        }
    case "enterprise-faq" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "enterprise_faq";
        }
    case "enterprise-lead-page" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "enterprise_lead_page";
        }
    case "fare-estimate" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "fare_estimate_v2";
        }
    case "fare_estimate_mob" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "fare_estimate_mob";
        }
    case "governance" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "governance";
        }
    case "insurance-faq" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "insurance_faq";
        }
    case "offers" :
        var match$4 = match.tl;
        if (!match$4) {
          return "offers";
        }
        switch (match$4.hd) {
          case "cashback" :
              var match$5 = match$4.tl;
              if (match$5 && !match$5.tl) {
                return "cashback";
              } else {
                return CategoryAnalyticsStore$PorterinFeature.$$default;
              }
          case "discount" :
              var match$6 = match$4.tl;
              if (match$6 && !match$6.tl) {
                return "discount";
              } else {
                return CategoryAnalyticsStore$PorterinFeature.$$default;
              }
          default:
            return CategoryAnalyticsStore$PorterinFeature.$$default;
        }
    case "order-history" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "order_history";
        }
    case "order-review" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "order_review";
        }
    case "packers-and-movers" :
        var match$7 = match.tl;
        if (!match$7) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        }
        var match$8 = match$7.tl;
        if (match$8) {
          if (match$8.tl) {
            return CategoryAnalyticsStore$PorterinFeature.$$default;
          } else {
            return "pnm_hyperlocal";
          }
        } else {
          return "pnm_city";
        }
    case "partners" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "partners";
        }
    case "porter-wallet-faq" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "porter_wallet_faq";
        }
    case "privacy-policy" :
    case "privacy-policy-v1" :
    case "privacy-policy-v2" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "privacy_policy";
        }
    case "referral-tnc" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "refferal_tnc";
        }
    case "services" :
        var match$9 = match.tl;
        if (!match$9) {
          return "seo_page";
        }
        if (!match$9.tl) {
          return "seo_page";
        }
        switch (match$9.hd) {
          case "courier" :
              if (match$9.tl.tl) {
                return CategoryAnalyticsStore$PorterinFeature.$$default;
              } else {
                return "courier_seo_page";
              }
          case "trucks" :
              if (match$9.tl.tl) {
                return CategoryAnalyticsStore$PorterinFeature.$$default;
              } else {
                return "trucks_seo_page";
              }
          case "two-wheelers" :
              if (match$9.tl.tl) {
                return CategoryAnalyticsStore$PorterinFeature.$$default;
              } else {
                return "2w_seo_page";
              }
          default:
            return CategoryAnalyticsStore$PorterinFeature.$$default;
        }
    case "spot-faq" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "spot_faq";
        }
    case "support" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "support";
        }
    case "terms-of-service" :
        var match$10 = match.tl;
        if (match$10) {
          if (match$10.hd === "partners" && !match$10.tl) {
            return "tos_partners";
          } else {
            return CategoryAnalyticsStore$PorterinFeature.$$default;
          }
        } else {
          return "terms_of_service";
        }
    case "tools" :
        var match$11 = match.tl;
        if (match$11 && match$11.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "utility_tools";
        }
    case "track-order" :
        if (match.tl) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        } else {
          return "track_order";
        }
    case "trucks" :
        var match$12 = match.tl;
        if (!match$12) {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        }
        var match$13 = match$12.tl;
        if (match$13) {
          if (match$13.tl) {
            return CategoryAnalyticsStore$PorterinFeature.$$default;
          } else {
            return "trucks_inventory";
          }
        } else {
          return "trucks";
        }
    case "two-wheelers" :
        var match$14 = match.tl;
        if (match$14 && !match$14.tl) {
          return "2w";
        } else {
          return CategoryAnalyticsStore$PorterinFeature.$$default;
        }
    default:
      return CategoryAnalyticsStore$PorterinFeature.$$default;
  }
}

export {
  getRoutePathList ,
  getPillarPageName ,
  getPillarOmsPageName ,
  getCategoryName ,
  getNumberedEventLabel ,
  getPageName ,
}
/* No side effect */
